module.exports = __webpack_public_path__ + "img/q3.40db6e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/elena/q3.png
// module id = EFpW
// module chunks = 1